export default __webpack_public_path__ + "static/icon-man-0230d8867f49a0ee2ab2620dd9115712.png";